import { render, staticRenderFns } from "./CreateIncident.vue?vue&type=template&id=64aac02a&scoped=true&"
import script from "./CreateIncident.vue?vue&type=script&lang=js&"
export * from "./CreateIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aac02a",
  null
  
)

export default component.exports